import { initialUserState } from "../user";
import { initialAppState } from "../app/app.state";
import { RootState } from "./root.reducer";
import { initialDocListState } from "modules/documents/data/redux/document-list/document-list.state";
import { initialDocDetailsState } from "modules/documents/data/redux/document-details/document-details.state";
import { initialDocSetupState } from "modules/documents/data/redux/document-setup/document-setup.state";
import { initialDocumentTypeState } from "modules/_shared/redux/document-type";

export type InitialStoreState = Omit<RootState, "api"> &
  Partial<Pick<RootState, "api">>;
const initialState: InitialStoreState = {
  app: initialAppState,
  user: initialUserState,
  documentList: initialDocListState,
  documentDetails: initialDocDetailsState,
  documentSetup: initialDocSetupState,
  documentType: initialDocumentTypeState
};

export default initialState;
